import { ReactNode } from "react";

import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type CanceledEntryProps = {
  timestamp: number;
  username: string | null;
  children?: ReactNode;
};

// TODO: no designs
const CanceledEntry = ({ timestamp, username, children }: CanceledEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Canceled</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Canceled}
      timestamp={timestamp}
      terminal
    >
      {children}
    </HistoryEntryWrapper>
  );
};

export default CanceledEntry;
